import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import IosShareIcon from '@mui/icons-material/IosShare';
import TimelineIcon from '@mui/icons-material/Timeline';
import React from 'react';
import { useParams } from 'react-router-dom';

import { useAssessmentFromId } from '~/client/hooks/assessment';
import {
  assessmentBundleRouteUtil,
  assessmentRouteUtil,
} from '~/client/routes';
import * as GQL from '~/graphql/generated/client';
import {
  QuickActionButton,
  QuickActionDrawer,
} from '~c/components/base/quick-action';

interface Props {
  className?: string;
}

const AssessmentRightPanel: React.FC<Props> = ({ className }) => {
  const { navigateTo } = assessmentRouteUtil.useHelper();

  return (
    <div className={className}>
      <QuickActionDrawer header={{ text: 'QUICK ACTIONS' }}>
        <QuickActionButton
          icon={IosShareIcon}
          onClick={() => navigateTo('SUBMIT_FOR_REVIEW')}
        >
          Submit for review
        </QuickActionButton>
        <QuickActionButton
          icon={AccountCircleOutlinedIcon}
          onClick={() => navigateTo('INVITE_TEAM')}
        >
          Invite team
        </QuickActionButton>
      </QuickActionDrawer>
    </div>
  );
};

export const AssessmentBundleFormRightPanel: React.FC<Props> = ({
  className,
}) => {
  const { projectId, assessmentId, bundleId } = useParams();

  const { assessment } = useAssessmentFromId(projectId, assessmentId);
  const controlBundleList = assessment?.policy?.controlBundleList ?? [];
  const quantitativeBundles = controlBundleList.filter((bundle) => {
    return (
      bundle._id === bundleId &&
      bundle.controls.some(
        (control) => control.answerType === GQL.AnswerType.TestScore
      )
    );
  });
  const { navigateTo } = assessmentBundleRouteUtil.useHelper();

  if (quantitativeBundles && quantitativeBundles.length > 0) {
    return (
      <div className={className}>
        <QuickActionDrawer header={{ text: 'QUICK ACTIONS' }}>
          <QuickActionButton
            icon={TimelineIcon}
            onClick={() => navigateTo('RISK_OVER_TIME')}
          >
            Risk Over Time
          </QuickActionButton>
        </QuickActionDrawer>
      </div>
    );
  }
  return null;
};

export default AssessmentRightPanel;
